import { Component, Input } from '@angular/core';
import { DashboardCta, ImportantTaskCard, StyledText } from '@bluecrew/crew-member-backend-angular-client';
import { NavController } from '@ionic/angular';
import { CtaHandlerService } from 'src/app/services/cta-handler.service';
import { SegmentCMOSService } from 'src/app/services/segment-cmos.service';
import { getTextStyle } from 'src/app/util/style-util';

@Component({
  selector: 'app-important-tasks-card',
  templateUrl: './important-tasks-card.component.html',
  styleUrls: ['./important-tasks-card.component.scss'],
})
export class ImportantTasksCardComponent {

  cardClass: string;
  cardIcon: string;

  @Input()
  get taskCard(): ImportantTaskCard { return this._taskCard; }
  set taskCard(taskCard: ImportantTaskCard) {
    this._taskCard = taskCard;
    this.cardIcon = taskCard.iconPath;
  }
  private _taskCard: ImportantTaskCard;

  constructor( private readonly navCtrl: NavController,
               private ctaHandlerService: CtaHandlerService,
               private segmentCMOS: SegmentCMOSService
             ) {}

  onTaskCardClick() {
    this.ctaHandlerService.handle(this.taskCard.cta);
    this.segmentCMOS.addEvent('importantTasksCard_clicked', {
      cardType: this.taskCard.cardType
    });
  }

  getCardStyle(): Map<string,string> {
    return this.taskCard.cardStyle ? getTextStyle(this.taskCard.cardStyle) : this.getCardDefaultOrangeStyle();
  }

  getTaskQuantityStyle(): Map<string,string> {
    return this.taskCard.taskQuantityStyle ? getTextStyle(this.taskCard.taskQuantityStyle) : 
                                             new Map().set("background-color", "#F57902");
  }

  getHeaderStyleOrDefault(styledText: StyledText): Map<string,string> {
    return styledText.styling ? getTextStyle(styledText.styling) : new Map().set("color", "#080912)");

  }

  getTextStyleOrDefault(styledText: StyledText): Map<string,string> {
    return styledText.styling ? getTextStyle(styledText.styling) : new Map().set("color", "#080912)");
  }

  private getCardDefaultOrangeStyle(): Map<string,string> {
    return new Map().set("background-color", "#FFD59F")
                    .set("color", "#080912");
  }
}
